import React, { useState, useEffect } from 'react';
import { ChevronDown, Music, Users, BookOpen, Heart, Star, Clock, CheckCircle, Menu, X, Phone, Mail, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';
import heroImage from './assets/Semendo a fé e a alegria do evangelho.jpg';
import logoImage from './assets/logocm.png';
import bgPattern from './assets/semeando-fe-alegria.png';
import capaFamiliaImage from './assets/capa-familia.jpg';
import metodologiaImage from './assets/metodologia-image.png';
import aulaVideo2Image from './assets/aula-video-conf-2.jpg';
import aulaVideo3Image from './assets/aula-video-conf-3-768x432-nova.jpg';
import aulaVideo2NovaImage from './assets/aula-video-conf-2-1024x576.jpg';
import image3NovaImage from './assets/image-3-768x327-nova.png';
import whatsappTestimonialImage from './assets/whatsapp-testimonial.jpg';
import whatsappImage1 from './assets/whatsapp-image-1.jpg';
import meninoBrasilSubstitutoImage from './assets/menino-brasil-substituto.png';
import whatsappButtonImage from './assets/whatsapp-button-updated.png';
import instagramIconImage from './assets/instagram-icon.png';
import youtubeIconImage from './assets/youtube-icon.png';
import ebookFm2CifrasImage from './assets/ebook-fm2-cifras.jpg';
import ebookFm3CantosMissaImage from './assets/ebook-fm3-cantos-missa.jpg';
import ebookFm4Image from './assets/ebook-fm4.jpg';

const EscolaCriançasMusicais: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };



  const plans = [
    {
      id: 0,
      title: "Plano Light",
      price: "R$29",
      period: "/mês",
      description: "",
      features: [
        "Acesso à Comunidade de Famílias Musicais",
        "Biblioteca Digital com e-books e aulas gravadas",
        "Bônus: 1 Aula Aberta por mês",
        "Suporte na Comunidade",
        "Ideal para quem quer começar a caminhada"
      ],
      whatsappMessage: "Olá, estive no site da Escola Crianças Musicais e gostaria de mais informações sobre o plano Light"
    },
    {
      id: 1,
      title: "Plano Premium",
      price: "R$99",
      period: "/semestre",
      description: "",
      features: [
        "Todos os benefícios do plano anterior",
        "Biblioteca Digital com e-books e aulas gravadas",
        "Bônus: Minicurso de Férias gratuito",
        "Suporte via comunidade",
        "Economia de R$75 por semestre"
      ],
      whatsappMessage: "Olá, estive no site da Escola Crianças Musicais e gostaria de mais informações sobre o plano Premium"
    },
    {
      id: 2,
      title: "Canções Católicas",
      price: "R$129",
      period: "/mês",
      description: "",
      features: [
        "2 Aulas Online Semanais (Prática e Teoria Musical)",
        "Todos os benefícios do plano anterior",
        "Orientação com professor(a) em grupo exclusivo",
        "Suporte via Whatsapp",
        "Foco em iniciação musical"
      ],
      whatsappMessage: "Olá, estive no site da Escola Crianças Musicais e gostaria de mais informações sobre o plano Canções Católicas"
    },
    {
      id: 3,
      title: "Crianças Musicais",
      price: "R$189",
      period: "/mês",
      description: "",
      features: [
        "3 Aulas Online Semanais (Teoria + Canções + Violão ou Piano)",
        "Todos os benefícios do plano anterior",
        "Foco na Leitura de Partitura",
        "Suporte via Whatsapp",
        "Economia de R$69/mês"
      ],
      whatsappMessage: "Olá, estive no site da Escola Crianças Musicais e gostaria de mais informações sobre o plano Crianças Musicais"
    },
    {
      id: 4,
      title: "Famílias Musicais",
      price: "R$249",
      period: "/mês",
      description: "",
      features: [
        "3 Aulas Online Semanais (Canto + Violão + Piano)",
        "Todos os benefícios do plano anterior",
        "Melhor opção para irmãos",
        "Suporte via Whatsapp",
        "Economia de R$138/mês"
      ],
      whatsappMessage: "Olá, estive no site da Escola Crianças Musicais e gostaria de mais informações sobre o plano Famílias Musicais"
    }
  ];

  const faqs = [
    {
      question: "O que é a Escola Crianças Musicais?",
      answer: "Somos uma escola online que usa a música para fortalecer a fé e a união da família. Acreditamos que todos podem ser musicais e que a música é uma forma de rezar e expressar o amor."
    },
    {
      question: "Quem pode participar? Precisa saber música?",
      answer: "Não precisa saber nada! Nossa escola é para famílias católicas com crianças (de 5 a 12 anos), catequistas e qualquer adulto que queira aprender músicas católicas. Começamos do zero, pelo canto, que é a forma mais fácil de aprender."
    },
    {
      question: "O que a metodologia de vocês tem de especial?",
      answer: "Nós focamos em aprender juntos, em família, com músicas católicas que já amamos. Em vez de focar só na técnica, valorizamos a prática, a vivência e a espiritualidade. Usamos melodias clássicas nas aulas de instrumento e o canto como base para tudo."
    },
    {
      question: "Quais instrumentos vocês ensinam?",
      answer: "Você pode aprender a tocar violão, teclado, ukulele e flauta doce."
    },
    {
      question: "Como são as aulas?",
      answer: "As aulas são online. Temos encontros ao vivo, em pequenos grupos, e também videoaulas gravadas. Você também terá acesso aos nossos e-books exclusivos e minicursos."
    },
    {
      question: "Por que é tão importante aprender em família?",
      answer: "Porque a casa é o melhor lugar para a criança aprender. Quando a família canta e toca junto, os laços ficam mais fortes e a fé se torna algo vivo e presente no dia a dia."
    },
    {
      question: "As aulas são só sobre técnica?",
      answer: "Não. Nossas aulas misturam técnica com espiritualidade. Para nós, tocar e cantar é também um jeito de rezar."
    },
    {
      question: "O que são os e-books e minicursos?",
      answer: "Os e-books são nossos livros de música com as canções cifradas e ilustradas. Os minicursos são aulas curtas e focadas em temas específicos, para você aprender algo novo em poucos dias."
    },
    {
      question: "A mensalidade pode aumentar?",
      answer: "Não, enquanto você estiver matriculado, o valor da sua mensalidade não muda. É a nossa forma de garantir que você possa continuar seu aprendizado sem surpresas."
    },
    {
      question: "Ao participar, fazemos parte de alguma comunidade?",
      answer: "Sim! Nossas famílias, catequistas e educadores formam uma verdadeira comunidade. Juntos, compartilhamos a alegria de usar a música para evangelizar e construir um lar cheio de fé."
    }
  ];

  const testimonials = [
    {
      name: "Mãe da Maria Clara",
      text: "\"O mais fantástico e peculiar é ensinar música através do repertório católico! Projeto corajoso, virtuoso e evangelizador. Ela já toca de ouvido, sem ficar presa nas cifras. Maria Clara surpreendeu ao pegar músicas sozinhas.\""
    },
    {
      name: "Mãe do Guido",
      text: "\"Gostei muito da dedicação e do profissionalismo nas aulas. Vejo grande avanço no Guido. A apresentação final de ano ficou linda!\""
    },
    {
      name: "Mãe do Davi",
      text: "\"O Davi conseguiu se desenvolver muito bem em pouco tempo. Com o curso foi bem melhor! As aulas são bem direcionadas... Com músicas católicas é melhor ainda! Ele ama as aulas de teoria musical.\""
    },
    {
      name: "Mãe do Felipe",
      text: "\"Fiquei muito feliz de ter encontrado o seu curso... gostei principalmente do fato do repertório ser católico e da história e experiência do seu trabalho, que é muito bonito.\""
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white shadow-md z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <img src={logoImage} alt="Escola Crianças Musicais" className="h-8 w-8 mr-2" />
              <span className="font-bold text-xl text-azul-profundo">Escola Crianças Musicais</span>
            </div>
            
            <div className="hidden md:flex items-center space-x-8">

              <button onClick={() => scrollToSection('mission')} className="text-gray-700 hover:text-laranja transition-colors font-medium">Quem Somos</button>
              <button onClick={() => scrollToSection('methodology')} className="text-gray-700 hover:text-laranja transition-colors font-medium">Pilares</button>
              <button onClick={() => scrollToSection('courses')} className="text-gray-700 hover:text-laranja transition-colors font-medium">Cursos</button>
              <button onClick={() => scrollToSection('ebook')} className="text-gray-700 hover:text-laranja transition-colors font-medium">E-books</button>
              <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-laranja transition-colors font-medium">Depoimentos</button>
              <button onClick={() => scrollToSection('plans')} className="text-gray-700 hover:text-laranja transition-colors font-medium">Planos</button>
              <button onClick={() => scrollToSection('partnerships')} className="text-gray-700 hover:text-laranja transition-colors font-medium">Parcerias</button>
              <a
                href="https://wa.me/5512988294043?text=Olá%2C%20gostaria%20de%20mais%20informações%20sobre%20a%20Escola%20Crianças%20Musicais%21"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full flex items-center space-x-2 transition-colors"
              >
                <img src={whatsappButtonImage} alt="WhatsApp" className="w-5 h-5" />
              </a>
            </div>

            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden text-gray-700 hover:text-laranja"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-2 pt-2 pb-3 space-y-1">

              <button onClick={() => scrollToSection('mission')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-laranja hover:bg-gray-50 rounded font-medium">Quem Somos</button>
              <button onClick={() => scrollToSection('methodology')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-laranja hover:bg-gray-50 rounded font-medium">Pilares</button>
              <button onClick={() => scrollToSection('courses')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-laranja hover:bg-gray-50 rounded font-medium">Cursos</button>
              <button onClick={() => scrollToSection('ebook')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-laranja hover:bg-gray-50 rounded font-medium">E-books</button>
              <button onClick={() => scrollToSection('benefits')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-laranja hover:bg-gray-50 rounded font-medium">Pilares</button>
              <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-laranja hover:bg-gray-50 rounded font-medium">Depoimentos</button>
              <button onClick={() => scrollToSection('plans')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-laranja hover:bg-gray-50 rounded font-medium">Planos</button>
              <button onClick={() => scrollToSection('partnerships')} className="block w-full text-left px-3 py-2 text-gray-700 hover:text-laranja hover:bg-gray-50 rounded font-medium">Parcerias</button>
              <a
                href="https://wa.me/5512988294043?text=Olá%2C%20gostaria%20de%20mais%20informações%20sobre%20a%20Escola%20Crianças%20Musicais%21"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center px-3 py-2 bg-green-500 hover:bg-green-600 text-white rounded font-medium transition-colors"
              >
                WhatsApp
              </a>
            </div>
          </div>
        )}
      </nav>
      {/* Hero Section */}
      <section id="hero" className="pt-16 min-h-screen flex items-center relative overflow-hidden">
        <div className="absolute inset-0">
          <div 
            className="w-full h-full bg-cover bg-center bg-fixed"
            style={{ backgroundImage: `url(${heroImage})` }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-azul-profundo/30 to-azul-claro/20"></div>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="mb-8">
              <img src={logoImage} alt="Escola Crianças Musicais" className="h-32 w-32 mx-auto mb-4 drop-shadow-[0_25px_25px_rgba(0,0,0,0.5)] animate-float" />
              <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg mb-6">
                Escola Crianças Musicais
              </h1>

            </div>
            
            <div className="mb-16">
              <p className="text-2xl md:text-3xl text-white drop-shadow-lg font-light">
                Incentivando Famílias Musicais
              </p>
            </div>
            
            <div className="flex justify-center animate-bounce-soft">
              <ChevronDown className="h-8 w-8 text-white drop-shadow-lg" />
            </div>
          </div>
        </div>
      </section>
      {/* Mission Section */}
      <section id="mission" className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">Quem Somos</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="bg-gradient-to-r from-azul-claro/10 to-laranja/10 rounded-xl p-6">
                <h3 className="text-2xl font-semibold text-azul-profundo mb-4">Nossa História</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  O canal <strong>Crianças Musicais</strong> nasceu em <strong>2020</strong>, na pandemia, criado por <strong>Estevão</strong> e <strong>Aline</strong>. 
                  Em <strong>2023</strong>, compartilhamos nossa experiência familiar com outras famílias, dando origem à Escola Crianças Musicais.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Hoje estamos nas <strong>5 regiões do Brasil</strong> e já tivemos alunos de comunidades brasileiras no exterior. 
                  Oferecemos cursos de violão, teclado, ukulele, flauta doce e canto, além de e-books e minicursos.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Nossa metodologia é centrada em repertório vivo com mais de 40 canções católicas, unindo técnica musical, espiritualidade e afeto. 
                  Com a música online, levamos educação musical de qualidade para famílias em <strong>cidades pequenas</strong>.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  O <strong>repertório católico</strong> serve como iniciação musical e fortalecimento da leitura, 
                  além de cantar temas essenciais para a evangelização familiar.
                </p>
                <p className="text-gray-700 leading-relaxed font-semibold text-laranja">
                  A escola se diferencia por seu ambiente acolhedor e por valorizar o aprendizado em família, 
                  com o sonho de ser referência em educação musical católica familiar.
                </p>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src={capaFamiliaImage} 
                alt="Família Crianças Musicais" 
                className="rounded-2xl shadow-2xl w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>
      {/* Differentials Section */}
      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">Ensinamos música a partir de Canções Católicas para toda família</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            <div className="text-center">
              <div className="bg-laranja/20 rounded-full p-4 w-16 h-16 mx-auto mb-4">
                <Users className="h-8 w-8 text-laranja mx-auto" />
              </div>
              <h3 className="font-semibold text-azul-profundo mb-2">Aprendizado em Família</h3>
              <p className="text-sm text-gray-600">Todos aprendem juntos</p>
            </div>
            
            <div className="text-center">
              <div className="bg-laranja/20 rounded-full p-4 w-16 h-16 mx-auto mb-4">
                <BookOpen className="h-8 w-8 text-laranja mx-auto" />
              </div>
              <h3 className="font-semibold text-azul-profundo mb-2">Material Autoral</h3>
              <p className="text-sm text-gray-600">Conteúdo exclusivo</p>
            </div>
            
            <div className="text-center">
              <div className="bg-laranja/20 rounded-full p-4 w-16 h-16 mx-auto mb-4">
                <Heart className="h-8 w-8 text-laranja mx-auto" />
              </div>
              <h3 className="font-semibold text-azul-profundo mb-2">Ambiente Acolhedor</h3>
              <p className="text-sm text-gray-600">Inclusivo e acessível</p>
            </div>
            
            <div className="text-center">
              <div className="bg-laranja/20 rounded-full p-4 w-16 h-16 mx-auto mb-4">
                <Clock className="h-8 w-8 text-laranja mx-auto" />
              </div>
              <h3 className="font-semibold text-azul-profundo mb-2">Planos Acessíveis</h3>
              <p className="text-sm text-gray-600">Para todos os bolsos</p>
            </div>
            
            <div className="text-center">
              <div className="bg-laranja/20 rounded-full p-4 w-16 h-16 mx-auto mb-4">
                <Star className="h-8 w-8 text-laranja mx-auto" />
              </div>
              <h3 className="font-semibold text-azul-profundo mb-2">Foco Espiritual</h3>
              <p className="text-sm text-gray-600">Afeto e fé</p>
            </div>
          </div>
        </div>
      </section>
      {/* Methodology Section */}
      <section 
        id="methodology" 
        className="section-padding bg-gradient-to-b from-white to-azul-claro/10 relative"
        style={{
          backgroundImage: `url(${bgPattern})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundBlendMode: 'overlay'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-white/95 to-azul-claro/90"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">Os 4 Pilares da Metodologia</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            <div id="pilar-repertorio" className="bg-white rounded-2xl p-6 shadow-lg card-hover">
              <div className="flex items-start mb-4">
                <div className="bg-laranja/20 rounded-full p-3 w-12 h-12 mr-4 flex-shrink-0">
                  <Music className="h-6 w-6 text-laranja mx-auto" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-azul-profundo mb-2">Repertório Vivo</h3>
                  <p className="text-gray-700">As canções são o ponto central de toda a aula. Ao invés de exercícios técnicos isolados, o aprendizado é construído diretamente sobre o repertório autoral da escola, a coleção Famílias Musicais.</p>
                </div>
              </div>
            </div>
            
            <div id="pilar-aprendizagem" className="bg-white rounded-2xl p-6 shadow-lg card-hover">
              <div className="flex items-start mb-4">
                <div className="bg-azul-claro/20 rounded-full p-3 w-12 h-12 mr-4 flex-shrink-0">
                  <Users className="h-6 w-6 text-azul-claro mx-auto" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-azul-profundo mb-2">Aprendizagem em Conjunto</h3>
                  <p className="text-gray-700">A escola acredita que todos aprendem com todos. Pais e filhos, juntos, tocam e cantam, criando um ambiente de prática coletiva que incentiva a colaboração e a superação mútua.</p>
                </div>
              </div>
            </div>
            
            <div id="pilar-formacao" className="bg-white rounded-2xl p-6 shadow-lg card-hover">
              <div className="flex items-start mb-4">
                <div className="bg-azul-profundo/20 rounded-full p-3 w-12 h-12 mr-4 flex-shrink-0">
                  <Star className="h-6 w-6 text-azul-profundo mx-auto" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-azul-profundo mb-2">Formação Integral</h3>
                  <p className="text-gray-700">A metodologia vai além da técnica instrumental. As aulas envolvem canto, ritmo, percepção musical, leitura de partitura e expressão corporal, garantindo um desenvolvimento musical completo e divertido.</p>
                </div>
              </div>
            </div>
            
            <div id="pilar-acompanhamento" className="bg-white rounded-2xl p-6 shadow-lg card-hover">
              <div className="flex items-start mb-4">
                <div className="bg-laranja/20 rounded-full p-3 w-12 h-12 mr-4 flex-shrink-0">
                  <Heart className="h-6 w-6 text-laranja mx-auto" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-azul-profundo mb-2">Acompanhamento Familiar</h3>
                  <p className="text-gray-700">A escola entende que o aprendizado é um processo que se estende para dentro de casa. Por isso, a metodologia inclui os pais ativamente, incentivando a vivência doméstica da fé através da música e transformando cada família em uma verdadeira orquestra.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <a
              href="#plans"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('plans');
              }}
              className="inline-flex items-center px-8 py-4 bg-laranja text-white font-bold rounded-full hover:bg-orange-600 transition-all transform hover:scale-105 shadow-lg"
            >
              Conhecer nossos planos
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>
          </div>
        </div>
      </section>
      {/* Courses & Delivery Section */}
      <section id="courses" className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">Nossos Cursos Online</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
              <div className="bg-gradient-to-r from-laranja/10 to-azul-claro/10 rounded-2xl p-8 card-hover">
                <h3 className="text-2xl font-bold text-azul-profundo mb-6">Canções Católicas</h3>
                <div className="space-y-4 mb-6">
                  <div className="flex items-center">
                    <Users className="h-5 w-5 text-laranja mr-3" />
                    <span className="text-gray-700">Até 8 alunos por turma</span>
                  </div>
                  <div className="flex items-center">
                    <Star className="h-5 w-5 text-laranja mr-3" />
                    <span className="text-gray-700">Iniciação musical e aperfeiçoamento</span>
                  </div>
                  <div className="flex items-center">
                    <Music className="h-5 w-5 text-laranja mr-3" />
                    <span className="text-gray-700">Repertório exclusivo com mais de 40 canções</span>
                  </div>
                  <div className="flex items-center">
                    <BookOpen className="h-5 w-5 text-laranja mr-3" />
                    <span className="text-gray-700">E-book com cifras e arranjos para a família</span>
                  </div>
                </div>
                <div className="border-t border-laranja/20 pt-4">
                  <h4 className="font-semibold text-azul-profundo mb-2">O que você aprende:</h4>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Cantar com afinação e articulação</li>
                    <li>• Percepção do tempo musical</li>
                    <li>• Primeiras notas e acordes</li>
                    <li>• Ritmos aplicados</li>
                    <li>• Melodia de ouvido</li>
                  </ul>
                  <p className="text-sm text-gray-700 mt-3">
                    <strong>Foco:</strong> O canto como ponte entre o aprendizado por imitação (com a referência dos adultos) e a iniciação em um instrumento acompanhante (violão, ukulele, teclado, flauta doce).
                  </p>
                </div>
              </div>
              
              <div className="bg-gradient-to-r from-azul-profundo/10 to-azul-claro/10 rounded-2xl p-8 card-hover">
                <h3 className="text-2xl font-bold text-azul-profundo mb-6">Curso de Instrumento</h3>
                <div className="space-y-4 mb-6">
                  <div className="flex items-center">
                    <Music className="h-5 w-5 text-azul-profundo mr-3" />
                    <span className="text-gray-700">Violão ou Piano</span>
                  </div>
                  <div className="flex items-center">
                    <Users className="h-5 w-5 text-azul-profundo mr-3" />
                    <span className="text-gray-700">Até 6 alunos por turma</span>
                  </div>
                  <div className="flex items-center">
                    <BookOpen className="h-5 w-5 text-azul-profundo mr-3" />
                    <span className="text-gray-700">Coleção de Melodias Clássicas</span>
                  </div>
                  <div className="flex items-center">
                    <Star className="h-5 w-5 text-azul-profundo mr-3" />
                    <span className="text-gray-700">Caminhada de estudos individuais</span>
                  </div>
                </div>
                <div className="border-t border-azul-profundo/20 pt-4">
                  <h4 className="font-semibold text-azul-profundo mb-2">O que você aprende:</h4>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Leitura de Partitura Musical</li>
                    <li>• Desenvolvimento Técnico-instrumental</li>
                    <li>• Rotina de estudos</li>
                  </ul>
                  <p className="text-sm text-gray-700 mt-3">
                    <strong>Foco:</strong> Aprender o instrumento com foco em músicas clássicas, que já são conhecidas por milhões de pessoas no mundo, garantindo um avanço gradual e consistente.
                  </p>
                </div>
              </div>
          </div>
          
          {/* Prova Social - Fotos das Aulas */}
          <div className="mt-16">
            <h3 className="text-2xl font-bold text-azul-profundo text-center mb-8">Veja nossas aulas em ação</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="relative overflow-hidden rounded-lg shadow-lg card-hover">
                <img 
                  src={aulaVideo2NovaImage} 
                  alt="Aula de música online" 
                  className="w-auto h-full object-cover"
                />
              </div>
              <div className="relative overflow-hidden rounded-lg shadow-lg card-hover">
                <img 
                  src={aulaVideo3Image} 
                  alt="Aula de música online" 
                  className="w-auto h-full object-cover"
                />
              </div>
              <div className="relative overflow-hidden rounded-lg shadow-lg card-hover">
                <img 
                  src={image3NovaImage} 
                  alt="Aula de música online" 
                  className="w-auto h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* O que você recebe Section */}
      <section id="benefits" className="section-padding bg-gradient-to-b from-azul-claro/10 to-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-azul-profundo mb-4">O que você recebe</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-md p-6 text-center card-hover">
              <div className="w-16 h-16 bg-laranja/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-laranja" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-azul-profundo mb-2">Aulas ao Vivo</h3>
              <p className="text-gray-600">Aulas semanais via Google Meet com interação em tempo real</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center card-hover">
              <div className="w-16 h-16 bg-laranja/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-laranja" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 4v16M17 4v16M3 8h4m10 0h4M3 16h4m10 0h4"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-azul-profundo mb-2">Área de Membros</h3>
              <p className="text-gray-600">Acesso exclusivo às aulas gravadas e materiais complementares</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center card-hover">
              <div className="w-16 h-16 bg-laranja/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-laranja" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-azul-profundo mb-2">E-books Exclusivos</h3>
              <p className="text-gray-600">Material didático completo para acompanhamento e estudo</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center card-hover">
              <div className="w-16 h-16 bg-laranja/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-laranja" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-azul-profundo mb-2">Saraus e Recitais</h3>
              <p className="text-gray-600">Eventos ao vivo para apresentação e integração das famílias</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center card-hover">
              <div className="w-16 h-16 bg-laranja/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-laranja" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-azul-profundo mb-2">Suporte Contínuo</h3>
              <p className="text-gray-600">Acompanhamento via comunidade e WhatsApp para tirar dúvidas</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center card-hover">
              <div className="w-16 h-16 bg-laranja/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-laranja" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-azul-profundo mb-2">Comunidade Ativa</h3>
              <p className="text-gray-600">Grupo exclusivo para compartilhamento e networking musical</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center card-hover">
              <div className="w-16 h-16 bg-laranja/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-laranja" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-azul-profundo mb-2">Minicursos de Férias</h3>
              <p className="text-gray-600">Aulas intensivas e temáticas para o período de férias</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center card-hover">
              <div className="w-16 h-16 bg-laranja/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-laranja" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-azul-profundo mb-2">Teoria Musical</h3>
              <p className="text-gray-600">Aulas gravadas para aplicação prática e de forma acessível</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 text-center card-hover">
              <div className="w-16 h-16 bg-laranja/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-laranja" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-azul-profundo mb-2">Trilhas de Aprendizado</h3>
              <p className="text-gray-600">Caminhos personalizados com vídeos de treinamento para estudos das próximas canções, níveis e instrumentos</p>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <a
              href="#plans"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('plans');
              }}
              className="inline-flex items-center px-8 py-4 bg-laranja text-white font-bold rounded-full hover:bg-orange-600 transition-all transform hover:scale-105 shadow-lg"
            >
              Garantir minha vaga
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>
          </div>
        </div>
      </section>
      {/* Photo Gallery Section */}
      {/* Plans Section */}
      {/* E-book Section */}
      <section id="ebook" className="section-padding bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">Conheça Nosso E-book</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
            <p className="text-gray-700 mt-4 text-lg">
              Material exclusivo para você começar sua jornada musical em família
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-azul-claro/10 to-laranja/10 rounded-2xl p-8 shadow-lg">
            <iframe 
              allowFullScreen
              allow="clipboard-write" 
              scrolling="no" 
              className="fp-iframe w-full rounded-xl shadow-md" 
              src="https://heyzine.com/flip-book/d009e9861b.html" 
              style={{ border: '1px solid lightgray', height: '600px' }}
              title="E-book Escola Crianças Musicais"
            ></iframe>
          </div>
          
          {/* Additional E-books */}
          <div className="mt-12">
            <h3 className="text-2xl font-bold text-center text-azul-profundo mb-8">Outros E-books Disponíveis</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div 
                className="relative overflow-hidden rounded-lg shadow-lg card-hover cursor-pointer"
                onClick={() => {
                  const img = new Image();
                  img.src = ebookFm2CifrasImage;
                  img.onload = () => {
                    const win = window.open('');
                    win.document.write(`
                      <html>
                        <head>
                          <title>E-book Famílias Musicais 2 - Cifras</title>
                          <style>
                            body { margin: 0; padding: 20px; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f5f5f5; }
                            img { max-width: 100%; max-height: 90vh; box-shadow: 0 10px 30px rgba(0,0,0,0.3); }
                          </style>
                        </head>
                        <body>
                          <img src="${ebookFm2CifrasImage}" alt="E-book Famílias Musicais 2 - Cifras" />
                        </body>
                      </html>
                    `);
                  };
                }}
              >
                <img 
                  src={ebookFm2CifrasImage} 
                  alt="E-book Famílias Musicais 2 - Cifras" 
                  className="w-auto h-full object-cover"
                />
              </div>
              
              <div 
                className="relative overflow-hidden rounded-lg shadow-lg card-hover cursor-pointer"
                onClick={() => {
                  const img = new Image();
                  img.src = ebookFm3CantosMissaImage;
                  img.onload = () => {
                    const win = window.open('');
                    win.document.write(`
                      <html>
                        <head>
                          <title>E-book Famílias Musicais 3 - Cantos para a Missa</title>
                          <style>
                            body { margin: 0; padding: 20px; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f5f5f5; }
                            img { max-width: 100%; max-height: 90vh; box-shadow: 0 10px 30px rgba(0,0,0,0.3); }
                          </style>
                        </head>
                        <body>
                          <img src="${ebookFm3CantosMissaImage}" alt="E-book Famílias Musicais 3 - Cantos para a Missa" />
                        </body>
                      </html>
                    `);
                  };
                }}
              >
                <img 
                  src={ebookFm3CantosMissaImage} 
                  alt="E-book Famílias Musicais 3 - Cantos para a Missa" 
                  className="w-auto h-full object-cover"
                />
              </div>
              
              <div 
                className="relative overflow-hidden rounded-lg shadow-lg card-hover cursor-pointer"
                onClick={() => {
                  const img = new Image();
                  img.src = ebookFm4Image;
                  img.onload = () => {
                    const win = window.open('');
                    win.document.write(`
                      <html>
                        <head>
                          <title>E-book Famílias Musicais 4</title>
                          <style>
                            body { margin: 0; padding: 20px; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f5f5f5; }
                            img { max-width: 100%; max-height: 90vh; box-shadow: 0 10px 30px rgba(0,0,0,0.3); }
                          </style>
                        </head>
                        <body>
                          <img src="${ebookFm4Image}" alt="E-book Famílias Musicais 4" />
                        </body>
                      </html>
                    `);
                  };
                }}
              >
                <img 
                  src={ebookFm4Image} 
                  alt="E-book Famílias Musicais 4" 
                  className="w-auto h-full object-cover"
                />
              </div>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <button
              onClick={() => scrollToSection('plans')}
              className="inline-flex items-center px-8 py-4 bg-laranja text-white font-bold rounded-full hover:bg-orange-600 transition-all transform hover:scale-105 shadow-lg"
            >
              Ver planos e preços
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </button>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section id="testimonials" className="section-padding bg-gradient-to-b from-white to-azul-claro/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">O que dizem as famílias musicais</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg card-hover">
                <div className="flex items-center mb-4">
                  <div className="bg-laranja/20 rounded-full p-3 mr-4">
                    <Users className="h-6 w-6 text-laranja" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-azul-profundo">{testimonial.name}</h4>
                  </div>
                </div>
                <p className="text-gray-700 italic leading-relaxed">"{testimonial.text}"</p>
                <div className="flex mt-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" />
                  ))}
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-12 text-center">
            <a
              href="#plans"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('plans');
              }}
              className="inline-flex items-center px-8 py-4 bg-laranja text-white font-bold rounded-full hover:bg-orange-600 transition-all transform hover:scale-105 shadow-lg"
            >
              Ver planos e preços
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>
          </div>
        </div>
      </section>
      <section id="plans" className="section-padding bg-gradient-to-b from-white to-azul-claro/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">Comece sua jornada hoje mesmo.</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            {plans.map((plan, index) => (
              <div 
                key={plan.id} 
                className={`relative rounded-2xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-105 ${
                  index === 3 
                    ? 'bg-gradient-to-br from-laranja to-orange-600 text-white scale-105 border-4 border-laranja/30' 
                    : 'bg-white border-2 border-gray-200'
                }`}
              >
                {index === 3 && (
                  <div className="absolute top-0 right-0 bg-yellow-400 text-azul-profundo px-4 py-1 rounded-bl-xl text-sm font-bold">
                    MAIS POPULAR
                  </div>
                )}
                
                <div className={`p-6 text-center ${index === 1 ? 'text-white' : ''}`}>
                  <h3
                    className={`text-xl font-bold mb-4 ${index === 3 ? 'text-white' : 'text-azul-profundo'}`}
                    style={{
                      fontSize: "32px"
                    }}>
                    {plan.title}
                  </h3>
                  <div className={`text-4xl font-bold mb-6 ${index === 3 ? 'text-white' : 'text-laranja'}`}>
                    {plan.price}
                    <span className={`text-lg font-normal ${index === 3 ? 'text-white/90' : 'text-gray-600'}`}>
                      {plan.period}
                    </span>
                  </div>
                  {plan.description}
                </div>
                
                <div className={`px-6 pb-6 ${index === 3 ? 'text-white' : ''}`}>
                  <ul className="space-y-3 mb-6">
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <CheckCircle className={`h-5 w-5 mr-3 flex-shrink-0 mt-0.5 ${
                          index === 3 ? 'text-white' : 'text-laranja'
                        }`} />
                        <span className={index === 3 ? 'text-white' : 'text-gray-700'}>
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>
                  
                  <a 
                    href={`https://wa.me/5512988294043?text=${encodeURIComponent(plan.whatsappMessage)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-full text-center block py-3 px-6 rounded-xl font-bold transition-all duration-300 ${
                      index === 3 
                        ? 'bg-white text-laranja hover:bg-gray-100 shadow-lg' 
                        : 'bg-laranja text-white hover:bg-orange-600'
                    }`}
                  >
                    Matricule-se Agora
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Plans Comparison Table */}
      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">Tabela Comparativa dos Planos</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
            <p className="text-gray-700 mt-4 text-lg">
              Escolha o plano ideal para sua família
            </p>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
              <thead className="bg-azul-profundo text-white">
                <tr>
                  <th className="px-6 py-4 text-left font-semibold">Recursos</th>
                  <th className="px-6 py-4 text-center font-semibold">Light</th>
                  <th className="px-6 py-4 text-center font-semibold">Premium</th>
                  <th className="px-6 py-4 text-center font-semibold">Canções Católicas</th>
                  <th className="px-6 py-4 text-center font-semibold">Crianças Musicais</th>
                  <th className="px-6 py-4 text-center font-semibold">Famílias Musicais</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Valor</td>
                  <td className="px-6 py-4 text-center text-laranja font-bold">R$29/mês</td>
                  <td className="px-6 py-4 text-center text-laranja font-bold">R$99/semestre</td>
                  <td className="px-6 py-4 text-center text-laranja font-bold">R$129/mês</td>
                  <td className="px-6 py-4 text-center text-laranja font-bold">R$189/mês</td>
                  <td className="px-6 py-4 text-center text-laranja font-bold">R$249/mês</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Aulas Online Semanais</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#FF0000",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#FF0000",
                      fontSize: "15px"
                    }}>❌</td>
                  <td className="px-6 py-4 text-center">1 (Cantar e Tocar)</td>
                  <td className="px-6 py-4 text-center">2 (Canto + Violão ou Piano)</td>
                  <td className="px-6 py-4 text-center">3 (Canto + Violão + Piano)</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Acesso à Comunidade</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Biblioteca Digital</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Aulas Abertas Mensais</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Minicurso de Férias</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Acesso Ilimitado às Aulas</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Orientação com Professor(a)</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Foco em Leitura de Partitura</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Opção para Irmãos</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>✓</td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-900">Economia</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>R$75/semestre</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "rgb(239, 68, 68)",
                      fontSize: "15px"
                    }}>❌</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>R$69/mês</td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{
                      fontWeight: "bold",
                      color: "#25d366",
                      fontSize: "20px"
                    }}>R$138/mês</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div className="mt-8 text-center">

            <a
              href="#plans"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('plans');
              }}
              className="inline-flex items-center px-8 py-4 bg-laranja text-white font-bold rounded-full hover:bg-orange-600 transition-all transform hover:scale-105 shadow-lg"
            >
              Escolher meu plano
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
              </svg>
            </a>
          </div>
        </div>
      </section>
      {/* Free Trial Section - After Comparison Table */}
      <section className="section-padding bg-gradient-to-r from-azul-profundo to-azul-claro text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Participe de uma Aula Gratuita</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full mb-8"></div>
            <p className="text-xl md:text-2xl mb-8 text-white/90">
              Experimente nossa metodologia única sem compromisso
            </p>
            <p className="text-lg mb-12 text-white/80 max-w-3xl mx-auto">
              Conheça de perto como transformamos a educação musical em uma experiência familiar e espiritual. 
              Sinta a energia das nossas aulas e veja por que centenas de famílias já fazem parte da nossa comunidade.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 flex-1 max-w-sm">
                <div className="text-3xl mb-4">🎵</div>
                <h3 className="text-xl font-semibold mb-2">Aula Experimental</h3>
                <p className="text-white/80">Aprenda verdadeiramente em uma aula ao vivo no Google Meet</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 flex-1 max-w-sm">
                <div className="text-3xl mb-4">👨‍👩‍👧‍👦</div>
                <h3 className="text-xl font-semibold mb-2">Aprendizado Conjunto</h3>
                <p className="text-white/80">Pais e filhos aprendendo juntos em ambiente acolhedor</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 flex-1 max-w-sm">
                <div className="text-3xl mb-4">✨</div>
                <h3 className="text-xl font-semibold mb-2">Sem Compromisso</h3>
                <p className="text-white/80">Avalie nosso método antes de decidir pela matrícula</p>
              </div>
            </div>
            
            <a
              href="https://api.whatsapp.com/send/?phone=5512988294043&text=Ol%C3%A1%2C+gostaria+de+agendar+minha+aula+gratuita+na+Escola+Crian%C3%A7as+Musicais%21&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-bold rounded-full transition-all transform hover:scale-105 shadow-lg text-lg"
            >
              <img src={whatsappButtonImage} alt="WhatsApp" className="w-6 h-6 mr-3" />
              Agendar Aula Gratuita
            </a>
          </div>
        </div>
      </section>
      {/* Partnerships Section */}
      <section id="partnerships" className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">Parcerias com Escolas Católicas e Paróquias</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
            <p className="text-gray-700 mt-4 text-lg max-w-3xl mx-auto">Estamos abertos a parcerias com Escolas Católicas e Paróquias que queiram criar um espaço exclusivo aos seus alunos</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="bg-gradient-to-r from-laranja/10 to-azul-claro/10 rounded-xl p-6">
                <h3 className="text-2xl font-semibold text-azul-profundo mb-4">Como Funciona</h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-laranja mr-3 flex-shrink-0 mt-0.5" />
                    <span>Criação de turmas exclusivas para alunos da sua escola</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-laranja mr-3 flex-shrink-0 mt-0.5" />
                    <span>Horários flexíveis adaptados à rotina escolar</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-laranja mr-3 flex-shrink-0 mt-0.5" />
                    <span>Conteúdo alinhado ao projeto pedagógico da escola</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-laranja mr-3 flex-shrink-0 mt-0.5" />
                    <span>Plataforma própria com área de membros exclusiva para alunos da escola</span>
                  </li>
                  <li className="flex items-start">
                    <CheckCircle className="h-5 w-5 text-laranja mr-3 flex-shrink-0 mt-0.5" />
                    <span>Eventos e apresentações integradas ao calendário escolar</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-gradient-to-r from-azul-profundo/10 to-laranja/10 rounded-xl p-6">
                <h3 className="text-2xl font-semibold text-azul-profundo mb-4">Benefícios da Parceria</h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">


                  </li>
                  <li className="flex items-start">
                    <Star className="h-5 w-5 text-laranja mr-3 flex-shrink-0 mt-0.5" />
                    <span>Fortalecimento da identidade e valores cristãos</span>
                  </li>
                  <li className="flex items-start">
                    <Star className="h-5 w-5 text-laranja mr-3 flex-shrink-0 mt-0.5" />
                    <span>Desenvolvimento integral dos alunos</span>
                  </li>
                  <li className="flex items-start">
                    <Star className="h-5 w-5 text-laranja mr-3 flex-shrink-0 mt-0.5" />
                    <span>Condições especiais e planos personalizados</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-azul-profundo to-azul-claro rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-6">Fale Conosco</h3>
              <p className="text-white/90 mb-6">
                Gostaríamos de apresentar nossa proposta detalhada e conversar como podemos levar música católica de qualidade para sua comunidade escolar.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <Mail className="h-5 w-5 text-laranja mr-3" />
                  <span>contato@criancasmusicais.com.br</span>
                </div>
                <div className="flex items-center">
                  <Phone className="h-5 w-5 text-laranja mr-3" />
                  <span>(12) 98829-4043</span>
                </div>
                <div className="flex items-center">
                  <Users className="h-5 w-5 text-laranja mr-3" />
                  <span>Atendimento personalizado para escolas</span>
                </div>
              </div>
              
              <div className="space-y-3">
                <a
                  href="https://wa.me/5512988294043?text=Olá%2C%20gostaria%20de%20saber%20mais%20sobre%20parcerias%20com%20escolas%20católicas"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full block text-center px-6 py-3 bg-laranja hover:bg-orange-600 text-white font-bold rounded-xl transition-all transform hover:scale-105 shadow-lg"
                >
                  Falar sobre Parceria via WhatsApp
                </a>

              </div>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <p className="text-gray-600 italic">
              "A música transforma vidas e fortalece comunidades. Juntos, podemos fazer a diferença."
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section-padding bg-gradient-to-b from-white to-azul-claro/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-azul-profundo mb-4">FAQ – Escola Crianças Musicais</h2>
            <div className="w-24 h-1 bg-laranja mx-auto rounded-full"></div>
          </div>
          
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-50 rounded-xl overflow-hidden">
                <button
                  onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                  className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-100 transition-colors"
                >
                  <span className="font-semibold text-azul-profundo">{faq.question}</span>
                  <ChevronDown className={`h-5 w-5 text-laranja transition-transform ${expandedFaq === index ? 'rotate-180' : ''}`} />
                </button>
                
                {expandedFaq === index && (
                  <div className="px-6 py-4 border-t border-gray-200">
                    <p className="text-gray-700">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="bg-azul-profundo text-white section-padding">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <Music className="h-8 w-8 text-laranja mr-2" />
                <span className="font-bold text-xl">Escola Crianças Musicais</span>
              </div>
              <p className="text-white/80">Semeando a alegria do evangelho</p>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4 text-laranja">Contato</h4>
              <div className="space-y-2">
                <div className="flex items-center">
                  <Phone className="h-4 w-4 mr-2" />
                  <span className="text-white/80">(12) 98829-4043</span>
                </div>
                <div className="flex items-center">
                  <Mail className="h-4 w-4 mr-2" />
                  <span className="text-white/80">escola@criancasmusicais.com.br</span>
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4 text-laranja">Links Úteis</h4>
              <div className="space-y-2">
                <button onClick={() => scrollToSection('ebook')} className="block text-left text-white/80 hover:text-laranja transition-colors">E-books</button>
                <button onClick={() => scrollToSection('courses')} className="block text-left text-white/80 hover:text-laranja transition-colors">Cursos</button>
                <button onClick={() => scrollToSection('plans')} className="block text-left text-white/80 hover:text-laranja transition-colors">Planos</button>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4 text-laranja">Redes Sociais</h4>
              <div className="flex space-x-4">
                <a href="https://www.youtube.com/@EscolaCriancasMusicais" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-laranja transition-colors">
                  <img src={youtubeIconImage} alt="YouTube" className="h-6 w-6" />
                </a>
                <a href="https://www.instagram.com/escolacriancasmusicais" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-laranja transition-colors">
                  <img src={instagramIconImage} alt="Instagram" className="h-6 w-6" />
                </a>
                <a href="https://api.whatsapp.com/send/?phone=5512988294043&text=Ol%C3%A1%2C+gostaria+de+mais+informa%C3%A7%C3%B5es+sobre+a+Escola+Crian%C3%A7as+Musicais%21&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-laranja transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.149-.197 0-.772.357-1.056.537-.284.18-.846.847-1.056 1.284-.209.437-.209.847-.209 1.284 0 .437.149.847.209 1.284.149.437.847 2.03 1.056 2.382.209.352.437.537.67.537.233 0 .846-.357 1.13-.537.284-.18.846-.847 1.056-1.284.209-.437.209-.847.209-1.284 0-.437-.149-.847-.209-1.284-.149-.437-.847-2.03-1.056-2.382-.209-.352-.437-.537-.67-.537-.233 0-.846.357-1.13.537-.284.18-.846.847-1.056 1.284-.209.437-.209.847-.209 1.284 0 .437.149.847.209 1.284.149.437.847 2.03 1.056 2.382.209.352.437.537.67.537.233 0 .846-.357 1.13-.537.284-.18.846-.847 1.056-1.284.209-.437.209-.847.209-1.284 0-.437-.149-.847-.209-1.284-.149-.437-.847-2.03-1.056-2.382-.209-.352-.437-.537-.67-.537-.233 0-.846.357-1.13.537-.284.18-.846.847-1.056 1.284-.209.437-.209.847-.209 1.284 0 .437.149.847.209 1.284.149.437.847 2.03 1.056 2.382.209.352.437.537.67.537z"/>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-white/20 mt-8 pt-8">
            <div className="flex flex-col items-center space-y-4">
              <img src={logoImage} alt="Escola Crianças Musicais" className="h-8 w-8" />
              <p className="text-white/60 text-center">© Escola Crianças Musicais — Todos os direitos reservados.</p>
            </div>
          </div>
        </div>
      </footer>
      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/5512988294043?text=Olá%2C%20gostaria%20de%20mais%20informações%20sobre%20a%20Escola%20Crianças%20Musicais%21"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50 flex items-center justify-center"
      >
        <img src={whatsappButtonImage} alt="WhatsApp" className="w-8 h-8" />
      </a>
    </div>
  );
};

export default EscolaCriançasMusicais;
